import React, { PureComponent } from 'react';
import { LoadClassification } from '../../../../../model/CORE';
import { MonitoredLoadBar, MonitoredLoadBarProps } from './MonitoredLoadBar';
import Utils from 'app/common/util/Utils';

interface EntryLoadBarProps extends Omit<MonitoredLoadBarProps, 'fillColor'> {
    hideLabel?: boolean;
}

export class EntryLoadBar extends PureComponent<EntryLoadBarProps> {
    static getFillColor = (loadClassification: LoadClassification, nonRelevant?: boolean): string => {
        switch (loadClassification) {
            case LoadClassification.NORMAL:
                return nonRelevant ? 'url(#normal-hashed)' : 'url(#normal)';
            case LoadClassification.LOW_THRESHOLD:
                return nonRelevant ? 'url(#low-threshold-hashed)' : 'url(#low-threshold)';
            case LoadClassification.HIGH_THRESHOLD:
                return nonRelevant ? 'url(#high-threshold-hashed)' : 'url(#high-threshold)';
            case LoadClassification.OVERLOAD:
                return nonRelevant ? 'url(#overload-hashed)' : 'url(#overload)';
            case LoadClassification.UNDEFINED:
            default:
                return '#262626';
        }
    };

    render() {
        let { label, ...otherProps } = this.props;

        if (Utils.isNotExists(label)) {
            label = 'E';
        }

        return (
            <MonitoredLoadBar
                label={this.props.hideLabel ? undefined : label}
                fillColor={EntryLoadBar.getFillColor}
                {...otherProps}
            />
        );
    }
}
